import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { ExtubationPatients } from './ExtubationPatients';
import { Detail, IDetail } from '../Detail';

/**
 * # Extubation
 * 
 * Extubation을 설명하세요.
 */
export const Extubation = types
  .model('Extubation')
  // --------------------------------------------------------------------------
  .props({
    predict_time: types.optional(types.string, ''), //  발관 실패 예측 완료 시간
    patients: types.optional(types.array(ExtubationPatients), []),
    detail: types.optional(Detail, {} as IDetail), // 에러 메시지
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model extubation --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IExtubation;
      (Object.keys(newProps) as TExtubationKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TExtubation = Instance<typeof Extubation>;
type TExtubationSnapshot = SnapshotOut<typeof Extubation>

export interface IExtubation extends TExtubation {}
export type TExtubationKeys = keyof TExtubationSnapshot & string;
export interface IExtubationSnapshot extends TExtubationSnapshot {}
export const createExtubation = () => 
  types.optional(Extubation, {} as TExtubation);